import React from 'react'

import './Footer.scss'

function Footer() {
  return (
    <div className="footer accent">
      <div className="w-container">
        <p className="paragraph">
          The place a footer would normally tell you that this stuff belonged to
          one person or company.
        </p>
      </div>
    </div>
  )
}

export default Footer
